module.exports = [
  ...require('./_magicItemRawList_DMG_t'),
  require('./talisman_of_pure_good'),
  require('./talisman_of_ultimate_evil'),
]
